import Vue from 'vue'
import {HTTP} from '@/utils/httpCommonUtil'
import flatPickr from 'vue-flatpickr-component';
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import format from 'date-fns/format'
import {getRestParamErrorMessage, getRestResponseErrorMessage} from '@/utils/serverErrorMessageUtil';
import MaskedInput from 'vue-text-mask';
import {Money} from 'v-money';

export interface PresidentsGoal {
  id: number,
  year: number,
  amount: string,
  oldAmount: string,
  isEditing: boolean,
  isSaving: boolean
}

export default Vue.component('presidents-goal-card', {
  name: 'PresidentsGoalCard',
  data () {
    let color: any;
    return {
      msg: 'PresidentsGoalCard',
      cardExpanded: false,
      color: color,
      loadingData: false,
      presidentsGoalErrorMessage: '',
      presidentsGoalData: [] as PresidentsGoal[],
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '$',
        precision: 2
      }
    }
  },
  components: {
    flatPickr,
    VueSimpleSpinner,
    BallPulseLoader,
    MaskedInput,
    Money
  },
  filters: {
    dateformat (dateISO: string) {
      let tempString: string = format(dateISO, 'MMM D, YYYY');
      return tempString;
    },
    currency: {
      read: function (value: any) {
        return '$' + value.toFixed(2)
      },
      write: function (value: any) {
        const toCheck = +value.replace(/[^\d.]/g, '');
        return isNaN(toCheck) ? 0 : toCheck;
      }
    } as any
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getPresidentsGoals()
      }
    },
    async getPresidentsGoals() {
      this.loadingData = true;
      try {
        const response = await HTTP.get('/api/presidents-goal/');
        response.data.data.forEach((record: any) => {
          record.isEditing = false;
          record.isSaving = false;
          record.oldAmount = 0;
        });
        this.presidentsGoalData = response.data.data;
        this.loadingData = false;
      } catch (error) {
        console.log('response Error!');
        this.loadingData = false;
        this.presidentsGoalErrorMessage = error;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred getting the Presidents goals.',
          duration: 5000
        });
      }
    },
    addPresidentsGoal() {
      this.presidentsGoalData.push(
        { id: +('-' + new Date().getTime()), year: 0, amount: '', oldAmount: '', isEditing: true, isSaving: false}
      );
    },
    editPresidentsGoal(presidentsGoal: PresidentsGoal) {
      presidentsGoal.oldAmount = presidentsGoal.amount;
      presidentsGoal.isEditing = !presidentsGoal.isEditing;
    },
    cancelEditPresidentsGoal(presidentsGoal: PresidentsGoal) {
      if (presidentsGoal.id < 0) {
        let index = this.presidentsGoalData.indexOf(presidentsGoal);
        this.presidentsGoalData.splice(index, 1);
      }
      presidentsGoal.amount = presidentsGoal.oldAmount;
      presidentsGoal.isEditing = !presidentsGoal.isEditing;
    },
    async writePresidentsGoal(presidentsGoal: PresidentsGoal) {
      presidentsGoal.isSaving = true;
      try {
        presidentsGoal.id < 0
             ? await HTTP.post('/api/presidents-goal/', presidentsGoal)
             : await HTTP.put(`/api/presidents-goal/${presidentsGoal.id}`,presidentsGoal);
        await this.getPresidentsGoals();
      } catch (error) {
        this.presidentsGoalErrorMessage = error;
        presidentsGoal.isSaving = false;
        let errorMessages = [];
        let noErrorsFound = true;
        errorMessages.push( getRestParamErrorMessage(error, 'amount') );
        errorMessages.forEach((errorMessage) => {
          if (!errorMessage.length) { return; }
          noErrorsFound = false;
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: errorMessage,
            duration: 5000
          });
        });
        if (noErrorsFound) {
          let generalError = getRestResponseErrorMessage(error);
          this.$notify({
            group: 'main',
            type: 'error',
            title: 'Error',
            text: generalError ? generalError : "An error occurred saving the president's goal.",
            duration: 5000
          });
        }
      }
    },
    async deletePresidentsGoal(presidentsGoal: PresidentsGoal) {
      try {
        await HTTP.delete(`/api/presidents-goal/${presidentsGoal.id}`);
        await this.getPresidentsGoals();
      } catch(error) {
        console.log('response Error!');
        this.presidentsGoalErrorMessage = error;
        this.loadingData = false;
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: "An error occurred deleting the president's goal.",
          duration: 5000
        });
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/settings/cards/presidentsgoal/PresidentsGoalCard.ts